// [init]

export default {


	namespaced: true,

	state: {
		// Listing of all testimonials ( Array )
		testimonialList: [],

		// Current Testimonial being manipulated ( viewed or edited ) ( Object )
        status: '',
        activeTestimonial: {}
	},

	mutations: {

		// Update testimonialList with new list
		// @params: Array
		updateTestimonialList( state, newList ) {
			state.testimonialList = newList;
		},

		// Add a testimonial into testimonialList
		addTestimonial( state, newTestimonial ) {
			state.testimonialList.push( newTestimonial );
		},

		// Delete a testimmonial from testimonialList
		// @params: identifier (String)
		deleteTestimonial( state, identifier ) {
			state.testimonialList = state.testimonialList.filter(testimonial => {
				return testimonial.id != identifier;
			});
		},

		// Update the current active Testimonial object
		// @params: newActiveTestimonial (Object)
		updateActiveTestimonial( state, newActiveTestimonial ) {
			state.activeTestimonial = newActiveTestimonial;
		},

		// Change status of testimonialForm
		// @params: newStatus (String)
		updateStatus( state, newStatus ) {
			state.status = newStatus;
		},

		resetState( state ) {
			state.status = '';
			state.activeTestimonial = {};
		}

	},

	actions: {
		
		/* 
		*  /GET testimonials API
		*  Get all testimonials from the server
		*  @return: Array
		*/
		getTestimonials( { commit, state } ) {

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/cms/testimonials',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateTestimonialList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id testimonials API
		*  Get a single testimonial from the server
		*  @params: Array (due to vuex limitations)
		*  [0]: identifier (String)
		*  [1]: action (String: view/edit)
		*  @return: Object
		*/
		getSingleTestimonial( { commit, state }, params ) {

			const identifier = params[0];
			const action = params[1];

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: 'cms/testimonials/' + identifier,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateActiveTestimonial', response.data );
					commit( 'updateStatus', action );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST testimonials API
		*  Add a new testimonial to the server
		*  @params: Object (testimonials data)
		*  @return: Object
		*/
		addTestimonial( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {
				const postData = {
					clientname: data.clientname,
					content: data.content,
					profilePhoto: data.profilePhoto,
				};

				global.axios.request({
					method: 'post',
					url: '/cms/testimonials/addnew',
					validateStatus: ( status ) => { return status == 201; },
					data: postData
				})
				.then(response => {
					commit( 'addTestimonial', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});


		},

		/* 
		*  /POST/:id testimonials API
		*  Edits an existing testimonial into the server
		*  @params: Object (testimonial data)
		*  @return: Object
		*/
		editTestimonial( { commit, state }, data ) {

			return new Promise ((resolve, reject ) => {
				console.log(data);
				const postData = {
					clientname: data.clientname,
					content: data.content,
					profilePhoto: data.profilePhoto,
				};

				global.axios.request({
					method: 'post',
					url: 'cms/testimonials/' + data.id + '/update',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					commit( 'addTestimonial', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /DELETE/:id testimonials API
		*  Removes an existing testimonial into the server
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		deleteTestimonial( { commit, state }, identifier ) {

			return new Promise ((resolve, reject ) => {

				global.axios.request({
					method: 'post',
					url: 'cms/testimonials/' + identifier + '/delete',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'deleteTestimonial', identifier );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		reset( { commit, state } ) {
			commit( 'resetState' );
		}

	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Testimonials.js